import React, { useState,useEffect } from "react";
import Gst from  './forms/gst/gst'
import Smtp from  './forms/smtp/smtp'
import Cashfree from  './forms/cashfree/cashFree'
import S3 from  './forms/s3/s3'
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
import { randers3data } from "../../../Services/SystemSettings/SystemServices";

function SystemSettings() {
  let className='info-box card stdiv';
  let ActiceClassName='info-box card stdiv sec-active';
  const [viewSettings, setViewSettings] = useState('view');
  const [s3ActiveClass, setS3ActiveClass] = useState(className);
  const [smtpActiveClass, setSmtpActiveClass] = useState(className);
  const [gstActiveClass, setGstActiveClass] = useState(className);
  const [cashfreeActiveClass, setCashfreeActiveClass] = useState(className);
  const navigate = useNavigate();
  const fixedKeys = {
    S3: 'S3',
    SMTP: 'SMTP',
    GST: 'GST',
    CASHFREE: 'CASHFREE'
  };

  const handleKeyClick = (key) => {
    console.log("Key clicked:", key);
    randers3data(key);
  };

  const setActiveClass=(divsec)=>{
    setS3ActiveClass(className)
    setSmtpActiveClass(className)
    setGstActiveClass(className)
    setCashfreeActiveClass(className)
    if(divsec=='S3'){
      setS3ActiveClass(ActiceClassName);
      setViewSettings('S3');
    }
    if(divsec=='SMTP'){
      setSmtpActiveClass(ActiceClassName);
      setViewSettings('SMTP');
    }
    // if(divsec=='GST'){
    //   setGstActiveClass(ActiceClassName);
    //   setViewSettings('GST');
    // }
    // if(divsec=='CASHFREE'){
    //   setCashfreeActiveClass(ActiceClassName);
    //   setViewSettings('CASHFREE');
    // }
  } 
  useEffect(() => {
  if(!checkPermissions('system_settings_page') || !checkPermissions('settings_navigation')){ 
      navigate('/')
    }
  },[])
  return (
    <div>
      <main id="main" className="main">
    <div className="pagetitle">
      <h1>Settings</h1> 
    </div> 

    <section className="section contact">

      <div className="row gy-4">

        <div className="col-xl-6">

          <div className="row">
            {checkPermissions('s3_settings') && 
            <div className='col-lg-6' onClick={()=>{setViewSettings('S3'); setActiveClass('S3'); handleKeyClick(fixedKeys.S3) }}>
              <div className={s3ActiveClass}>
                <i className="bi bi-bucket"></i>
                <h3>S3</h3>
                <p>Application S3 settings </p>
              </div>
            </div> }
            {checkPermissions('smtp_settings') && 
            <div className='col-lg-6' onClick={()=>{setViewSettings('SMTP'); setActiveClass('SMTP'); handleKeyClick(fixedKeys.SMTP) }}>
              <div className={smtpActiveClass} >
                <i className="bi bi-mailbox2"></i>
                <h3>SMTP</h3>
                <p>Application SMTP settings </p>
              </div>
            </div> }
            {/* {checkPermissions('cashfree_settings') && 
            <div className='col-lg-6' onClick={()=>{setViewSettings('CASHFREE'); setActiveClass('CASHFREE'); handleKeyClick(fixedKeys.CASHFREE) }}>
              <div className={cashfreeActiveClass}  name="CASHFREE" id="cashfreesec" idname="cashfreediv">
                <i className="bi bi-cash-coin"></i>
                <h3>Cashfree</h3>
                <p>Payment API Details</p> 
              </div>
            </div> }
            {checkPermissions('gst_settings') && 
            <div className='col-lg-6'  onClick={()=>{setViewSettings('GST'); setActiveClass('GST'); handleKeyClick(fixedKeys.GST)}}>
              <div className={gstActiveClass}>
                <i className="bi bi-cash-coin"></i>
                <h3>GST</h3>
                <p>Goods Service Tax</p>
              </div>
            </div>} */}

          </div>

        </div>

        <div className="col-xl-6">
          <div className="card p-4"> 
             {viewSettings=="GST"?<Gst />:''} 
             {viewSettings=="SMTP"?<Smtp />:''} 
             {viewSettings=="CASHFREE"?<Cashfree />:''}
             {viewSettings=="S3"?<S3 />:''}
          </div>
        </div>
      </div>

    </section>

  </main>
    </div>
  );
}
export default SystemSettings;
